import {helpIntroductionString} from '../HelpStrings'

export default function HelpIntroduction(props){
      return (
      <span>
          {helpIntroductionString}
      </span>);
}
